import React, { useEffect, useState } from "react";
import * as actionCreators from "../../actions";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Alert, Fade, Modal } from "react-bootstrap";
import { sexOptions, useOptions } from "./../../utilities";
import {
  faHome,
  faUniversalAccess,
  faShoppingBag,
  faMotorcycle,
  faBriefcase,
  faBicycle,
  faPaw,
  faHeartCircleCheck,
  faLaptop,
  faHeadphonesSimple,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import motoICON from "../../assets/moto.svg";
import apICON from "../../assets/ap.svg";
import bolsoICON from "../../assets/bolso.svg";
import empleabilidadICON from "../../assets/empleabilidad.svg";
import hogarICON from "../../assets/hogar.svg";
import mawdyICON from "../../assets/family.svg";
import petsIcon from "../../assets/pawprint.svg";
import billIcon from "../../assets/payment.svg";
import notebookICON from "../../assets/notebook.svg";
import tecnologiaICON from "../../assets/tecnologia.svg";
import biciICON from "../../assets/bici.svg";
import saludICON from "../../assets/salud.svg";
import SpinnerLoading from "../../Components/SpinnerLoading";
import ItemMenu from "./ItemMenu";
import Inputs from "../../Components/Inputs";
import Cotizar from "../../Components/ButtonQuote";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { options } from "../../actions/webServices";
import useLoading from "../../hooks/useLoading"

function Menu({
  titularData,
  vehicleData,
  firstStep,
  menu,
  searchCities,
  searchModels,
  cities,
  provinces,
  moto,
  selectMenu,
  changeSumAssured,
  arrPayMethod,
  user,
  handleChange,
  loading,
  setLoading,
  resetData,
  company,
  resetCities,
  nomlcia,
  availableSections,
  waitingCities
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, showLoading } = useLoading();

  const availableSection =
    availableSections.find(
      (section) =>
        section.sec === firstStep.codsec && section.company === company
    ) !== undefined;

  const handleChangeProvinces = async (province) => {
    handleChange({ step: "firstStep", target: { name: "city", value: "" } });
    if (!cities.filter((city) => city.codprv === province.value)?.length > 0) {
      await searchCities(province.value, firstStep.codcia, null, dispatch);
    }
  };
  const handleChangeBrand = (brand) => {
    setLoading();
    searchModels(brand.value, firstStep.year);
  };

  const handleChangeModel = (e) => {
    let sum = moto.motoSumAssured.find((item) => item.value === e.value)?.label;
    if (!sum) {
      changeSumAssured("$ 0");
      return;
    }
    const price = "$ " + sum.toLocaleString("es");
    changeSumAssured(price);
  };

  const normalizeDNI = (e) =>
    (e.target.value = e.target.value.replace(/\D/g, "").substr(0, 8));

  const normalizeYear = (e) => {
    e.target.value = e.target.value.substr(0, 4);
    setLoading();
    searchModels(firstStep.brand, e.target.value);
  };

  const defaultsInputs = [
    {
      id: 1,
      type: "tel",
      step: "firstStep",
      value: firstStep.dni,
      name: "dni",
      placeholder: "DNI",
      change: normalizeDNI,
      disabled: user.disableInputs,
    },
    {
      id: 2,
      type: "email",
      step: "firstStep",
      value: firstStep.email,
      name: "email",
      placeholder: "E-mail",
      disabled: user.disableInputs && firstStep.edit,
    },
    {
      id: 3,
      type: "date",
      step: "firstStep",
      value: firstStep.birthday,
      name: "birthday",
      placeholder: "Fecha de Nacimiento",
      disabled: user.disableInputs,
    },
    {
      id: 4,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.province,
      name: "province",
      placeholder: "Provincia",
      options: provinces,
      change: handleChangeProvinces,
      disabled: user.disableInputs && firstStep.edit,
    },
    {
      id: 5,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.city,
      name: "city",
      placeholder: "Ciudad",
      options: cities.filter((c) => c.codprv === firstStep.province),
      disabled: user.disableInputs && firstStep.edit,
    },
  ];

  const inputsMoto = [
    {
      id: 11,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.payMethod,
      name: "payMethod",
      placeholder: "Forma de pago",
      options: arrPayMethod.filter(
        (method) => method.codsec === "32"
      ) /*payMethodMoto*/,
    },
    {
      id: 6,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.brand,
      name: "brand",
      placeholder: "Marca",
      options: moto.motoBrand,
      change: handleChangeBrand,
      disabled: loading,
    },
    {
      id: 7,
      type: "number",
      step: "firstStep",
      value: firstStep.year,
      name: "year",
      placeholder: "Año",
      change: normalizeYear,
      disabled: company === 2 || company === 52,
    },
    {
      id: 8,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.model,
      name: "model",
      placeholder: loading ? "Buscando modelos..." : "Versión - Modelo",
      options: moto.motoModel,
      change: handleChangeModel,
    },
    {
      id: 9,
      type: "text",
      step: "firstStep",
      value: firstStep.sumAssured,
      name: "sumAssured",
      placeholder: "Suma Asegurada",
      disabled: true,
    },
    {
      id: 1,
      type: "tel",
      step: "firstStep",
      value: firstStep.dni,
      name: "dni",
      placeholder: "DNI",
      change: normalizeDNI,
      disabled: user.disableInputs,
    },
    {
      id: 10,
      type: "selectMenu",
      step: "titularData",
      value: titularData.genre,
      name: "genre",
      placeholder: "Sexo",
      options: sexOptions,
      disabled: user.disableInputs,
    },
    {
      id: 3,
      type: "date",
      step: "firstStep",
      value: firstStep.birthday,
      name: "birthday",
      placeholder: "Fecha de Nacimiento",
      disabled: user.disableInputs,
    },
    {
      id: 4,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.province,
      name: "province",
      placeholder: "Provincia",
      options: provinces,
      change: handleChangeProvinces,
      disabled: user.disableInputs && firstStep.edit,
    },
    {
      id: 5,
      type: "selectMenu",
      step: "firstStep",
      value: firstStep.city,
      name: "city",
      placeholder: "Ciudad",
      options: cities.filter((c) => c.codprv === firstStep.province),
      disabled: user.disableInputs && firstStep.edit,
    },
    {
      id: 2,
      type: "email",
      step: "firstStep",
      value: firstStep.email,
      name: "email",
      placeholder: "E-mail",
      disabled: user.disableInputs,
    },
  ];

  const listMenu = [
    { id: 8, icon: hogarICON, title: "Combinado Familiar", value: "familiar" },
    {
      id: 27,
      icon: mawdyICON,
      title: "Asistencia Hogar Premium",
      value: "assist",
    },
    {
      id: 12,
      icon: apICON,
      title: "Accidentes Personales",
      value: "personal",
    },
    { id: 22, icon: apICON, title: "Vida Temporal", value: "life" },
    {
      id: 14,
      icon: saludICON,
      title: "Seguro de Salud",
      value: "health",
    },
    {
      id: 19,
      icon: bolsoICON,
      title: "Bolso Protegido",
      value: "protected",
    },
    { id: 32, icon: motoICON, title: "Motovehículos", value: "moto" },
    {
      id: 62,
      icon: empleabilidadICON,
      title: "Empleabilidad",
      value: "employed",
    },
    { id: 57, icon: biciICON, title: (company !== 4 && company !==54) ? "Movilidad" : "Bicicletas", value: "bicy" },
    { id: 64, icon: petsIcon, title: "Mascotas", value: "pets" },
    { id: 159, icon: notebookICON, title: "Notebook Protegida", value: "note" },
    {
      id: 161,
      icon: tecnologiaICON,
      title: "Tecnología Portátil",
      value: "tecno",
    },
    {
      id: 65,
      icon: billIcon,
      title: "Salidera ATM",
      value: "billprotected",
    },
    {
      id: 70,
      icon: tecnologiaICON,
      title: "Celulares",
      value: "billprotected",
    },
    {
      id: 71,
      icon: notebookICON,
      title: "Notebook/Tablet",
      value: "billprotected",
    },
  ];

  const [inputs, setInputs] = useState(defaultsInputs);
  const [iconCotizar, setIconCotizar] = useState(hogarICON);

  useEffect(() => {
    if (firstStep.type === "moto") {
      if (company === 2 || company === 52) {
        const numfact = {
          id: 12,
          type: "text",
          step: "firstStep",
          value: firstStep.facpol,
          name: "facpol",
          placeholder: "N° Factura",
        };
        setInputs(inputsMoto.splice(0, 1, numfact));
      }
      if (company === 3 || company === 53) {
        const use = {
          id: 13,
          type: "select",
          step: "vehicleData",
          value: vehicleData.use,
          name: "use",
          placeholder: "Uso",
          options: useOptions,
        };
        setInputs({ ...inputsMoto, use });
      }
      setInputs(inputsMoto);
      if (company === 4 || company === 54) {
        const inputsFiltered = inputsMoto.filter(
          (input) => input.name !== "sumAssured"
        );
        setInputs(inputsFiltered);
      }
    } else if (firstStep.codsec === 27) {
      //MAWDY
      const city = {
        id: 5,
        type: "selectMenu",
        step: "firstStep",
        value: firstStep.city,
        name: "city",
        options: cities.filter((c) => c.codprv === firstStep.province),
        placeholder: "Ciudad",
        disabled: false,
      };
      const name = {
        id: 6,
        type: "text",
        step: "titularData",
        value: titularData.name,
        name: "name",
        placeholder: "Nombre",
        disabled: false,
      };
      const lastname = {
        id: 7,
        type: "text",
        step: "titularData",
        value: titularData.lastname,
        name: "lastname",
        placeholder: "Apellido",
        disabled: false,
      };
      const codpos = {
        id: 8,
        type: "number",
        step: "titularData",
        value: titularData.postalcode,
        name: "postalcode",
        placeholder: "Código Postal",
        disabled: false,
      };
      defaultsInputs.splice(defaultsInputs.length - 1, 1, city);
      defaultsInputs.unshift(name, lastname);
      defaultsInputs.push(codpos);
      const index = defaultsInputs.findIndex((input) => input.name === "email");
      if (index !== -1) {
        defaultsInputs.splice(index, 1);
      }
      setInputs(
        defaultsInputs.map((e) => {
          if (e.name === "dni" || e.name === "birthday") {
            return { ...e, disabled: false };
          } else return e;
        })
      );
    } else {
      setInputs(defaultsInputs);
    }
    setIconCotizar(listMenu.find((e) => e.id === firstStep.codsec)?.icon);
  }, [
    firstStep.type,
    firstStep.dni,
    firstStep.cuil,
    firstStep.email,
    firstStep.birthday,
    firstStep.province,
    firstStep.city,
    firstStep.brand,
    firstStep.year,
    firstStep.model,
    firstStep.sumAssured,
    firstStep.payMethod,
    firstStep.plan,
    firstStep.price,
    firstStep.facpol,
    firstStep.codpos,
    titularData,
    cities,
    moto,
    company,
    vehicleData.use,
  ]);

  useEffect(() => {
    if (!user.disableInputs) {
      resetData();
      navigate("/");
    }
    setLoading(false);
    const menuFilter = menu.filter((it) => it.codsec !== menu[0]?.codsec);
    if (menuFilter.length === 0) {
      selectMenu({
        value: "protected",
        id: menu[0]?.codsec,
        codcia: menu[0]?.codcia,
      });
    }
  }, []);

  useEffect(() => {
    if (!user?.email?.startsWith("CA")) {
      if (!user.token) {
        handleChange({
          step: "firstStep",
          target: { name: "city", value: "" },
        });
        handleChange({
          step: "firstStep",
          target: { name: "province", value: "" },
        });
        resetCities();
      } else {
        resetCities();
        searchCities(firstStep.province, firstStep.codcia, nomlcia);
      }
    }
  }, [firstStep.codcia]);

  // useEffect(() => {
  //   if (!user?.email?.startsWith("CA")) {
  //     if (!user.token) {
  //       handleChange({
  //         step: "firstStep",
  //         target: { name: "city", value: "" },
  //       });
  //       handleChange({
  //         step: "firstStep",
  //         target: { name: "province", value: "" },
  //       });
  //       resetCities();
  //     } else {
  //       resetCities();
  //       searchCities(firstStep.province, firstStep.codcia, nomlcia);
  //     }
  //   }

  //   if (firstStep.type === "moto") {
  //     if (company === 2 || company === 52) {
  //       const numfact = {
  //         id: 12,
  //         type: "text",
  //         step: "firstStep",
  //         value: firstStep.facpol,
  //         name: "facpol",
  //         placeholder: "N° Factura",
  //       };
  //       setInputs(inputsMoto.splice(0, 1, numfact));
  //     }
  //     if (company === 3 || company === 53) {
  //       const use = {
  //         id: 13,
  //         type: "select",
  //         step: "vehicleData",
  //         value: vehicleData.use,
  //         name: "use",
  //         placeholder: "Uso",
  //         options: useOptions,
  //       };
  //       setInputs({ ...inputsMoto, use });
  //     }
  //     setInputs(inputsMoto);
  //     if (company === 4 || company === 54) {
  //       const inputsFiltered = inputsMoto.filter(
  //         (input) => input.name !== "sumAssured"
  //       );
  //       setInputs(inputsFiltered);
  //     }
  //   } else if (firstStep.codsec === 27) {
  //     //MAWDY
  //     const city = {
  //       id: 5,
  //       type: "selectMenu",
  //       step: "firstStep",
  //       value: firstStep.city,
  //       name: "city",
  //       options: cities.filter((c) => c.codprv === firstStep.province),
  //       placeholder: "Ciudad",
  //       disabled: false,
  //     };
  //     const name = {
  //       id: 6,
  //       type: "text",
  //       step: "titularData",
  //       value: titularData.name,
  //       name: "name",
  //       placeholder: "Nombre",
  //       disabled: false,
  //     };
  //     const lastname = {
  //       id: 7,
  //       type: "text",
  //       step: "titularData",
  //       value: titularData.lastname,
  //       name: "lastname",
  //       placeholder: "Apellido",
  //       disabled: false,
  //     };
  //     const codpos = {
  //       id: 8,
  //       type: "number",
  //       step: "titularData",
  //       value: titularData.postalcode,
  //       name: "postalcode",
  //       placeholder: "Código Postal",
  //       disabled: false,
  //     };
  //     defaultsInputs.splice(defaultsInputs.length - 1, 1, city);
  //     defaultsInputs.unshift(name, lastname);
  //     defaultsInputs.push(codpos);

  //     setInputs(
  //       defaultsInputs.map((e) => {
  //         if (e.name === "dni" || e.name === "birthday") {
  //           return { ...e, disabled: false };
  //         } else return e;
  //       })
  //     );
  //   } else {
  //     setInputs(defaultsInputs);
  //   }
  //   switch (firstStep.codsec) {
  //     case 12:
  //       return setIconCotizar(apICON);
  //     case 19:
  //       return setIconCotizar(bolsoICON);
  //     case 32:
  //       return setIconCotizar(motoICON);
  //     case 62:
  //       return setIconCotizar(empleabilidadICON);
  //     case 57:
  //       return setIconCotizar(biciICON);
  //     case 64:
  //       return setIconCotizar(faPaw);
  //     case 14:
  //       return setIconCotizar(saludICON);
  //     case 8:
  //       return setIconCotizar(hogarICON);
  //     case 159:
  //       return setIconCotizar(notebookICON);
  //     case 161:
  //       return setIconCotizar(tecnologiaICON);
  //     default:
  //       return setIconCotizar(hogarICON);
  //   }
  // }, [firstStep.type]);

  useEffect(() => {
    (company === 5 || company === 8) && navigate("/policy");
  }, []);

  return (
    <>
      <Fade appear in>
        <div>
          {firstStep.haveDiscount && (
            // <p className="mt-4 text-center">{firstStep.msgpde}</p>
            <Alert className="alertaDescuento" variant={"primary"}>
              <FontAwesomeIcon className="me-2" icon={faInfoCircle} />
              {firstStep.msgpde}
            </Alert>
          )}
          {availableSection && (
            // <p className="mt-4 text-center text-danger">
            //   Sección deshabilitada
            // </p>
            <Alert className="alertaDescuento" variant={"danger"}>
              <FontAwesomeIcon className="me-2" icon={faInfoCircle} />
              Sección deshabilitada
            </Alert>
          )}
          <div
            className={`mn-menu row shadow-sm ${(firstStep.haveDiscount || availableSection) && "alertaMenu"
              }`}
          >
            <div className="d-flex mb-3 mt-2 p-2 w-auto mx-auto border rounded-3 mn-items">
              {menu ? (
                listMenu.map((item) => {
                  const findMenu = menu.find((it) => it.codsec === item.id);
                  if (findMenu) {
                    return (
                      <ItemMenu
                        key={item.id}
                        id={item.id}
                        value={item.value}
                        icon={item.icon}
                        title={item.title}
                        active={firstStep.codsec === item.id}
                        codcia={findMenu.codcia}
                        haveDiscount={findMenu.hasdes}
                        discount={findMenu.porpde}
                        msgpde={findMenu.msgpde}
                        disabled={waitingCities}
                      />
                    );
                  } else {
                    <></>;
                  }
                })
              ) : (
                <SpinnerLoading />
              )}
            </div>
            <div className="mn container max-shadow">
              <div className="ct-2-cols">
                <div
                  className={`ct-inputs row row-cols-${inputs.length > 6 ? "4" : "3"
                    }`}
                >
                  {inputs.map((item) => (
                    <div key={item.id} className="col my-1">
                      <Inputs
                        id={item.id}
                        name={item.name}
                        type={item.type}
                        options={item.options}
                        value={item.value}
                        placeholder={item.placeholder}
                        step={item.step}
                        change={item.change}
                        maxLength={item.maxLength}
                        disabled={item.disabled}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {loading || isLoading ? (
              <div className="d-flex justify-content-end align-items-center m-0 mb-2 pe-4">
                <SpinnerLoading />
              </div>
            ) : (
              <>
                <div
                  className={`d-flex ${user?.nro
                    ? "justify-content-between"
                    : "justify-content-end"
                    } align-items-center m-0 ct-cotizar-p res-error`}
                >
                  {user?.nro && (
                    <p className="ms-1 font-navbar fw-bold res-login-active">
                      Número de intención: {user?.nro}
                    </p>
                  )}
                  {!waitingCities?
                    <Cotizar
                      className={"ct-cotizar ct-cotizar-w"}
                      disabled={availableSection}
                      icon={iconCotizar}
                    />
                  :
                    <SpinnerLoading></SpinnerLoading>
                  }
                </div>
              </>
            )}
          </div>
          <footer className="footer-mn">
            <p className="font-copy m-0">
              {" "}
              Platform Evo {process.env.REACT_APP_VERSION} ©{" "}
              {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </footer>
        </div>
      </Fade>
      <Modal
        show={!user.habilitado} /*onHide={handleClose} className={"qs-inputs"}*/
      >
        <Modal.Header>
          <Modal.Title>Atención!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2>Usuario no habilitado para realizar ventas.</h2>
        </Modal.Body>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {
    firstStep: state.mainReducer.firstStep,
    vehicleData: state.mainReducer.vehicleData,
    titularData: state.mainReducer.titularData,
    menu: state.mainReducer.menu,
    cities: state.mainReducer.cities,
    provinces: state.mainReducer.provinces,
    moto: state.mainReducer.moto,
    payMethodMoto: state.mainReducer.payMethodMoto,
    arrPayMethod: state.mainReducer.arrPayMethod,
    availableSections: state.mainReducer.availableSections,
    user: state.mainReducer.user,
    loading: state.mainReducer.loading,
    codpmpol: state.mainReducer.codpmpol,
    company: state.mainReducer.company,
    nomlcia: state.mainReducer.nomlcia,
    waitingCities: state.mainReducer.waitingCities
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
